"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = CardBlogImage;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// components
function CardBlogImage(_ref) {
  var image = _ref.image,
      title = _ref.title,
      description = _ref.description,
      color = _ref.color;
  var bgColor = {
    blueGray: "bg-blueGray-500",
    red: "bg-red-500",
    orange: "bg-orange-500",
    amber: "bg-amber-500",
    emerald: "bg-emerald-500",
    teal: "bg-teal-500",
    lightBlue: "bg-lightBlue-500",
    indigo: "bg-indigo-500",
    purple: "bg-purple-500",
    pink: "bg-pink-500"
  };
  var textColor = {
    blueGray: "text-blueGray-500",
    red: "text-red-500",
    orange: "text-orange-500",
    amber: "text-amber-500",
    emerald: "text-emerald-500",
    teal: "text-teal-500",
    lightBlue: "text-lightBlue-500",
    indigo: "text-indigo-500",
    purple: "text-purple-500",
    pink: "text-pink-500"
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "relative flex flex-col min-w-0 break-words bg-white w-full mb-6 shadow-lg rounded-lg " + bgColor[color]
  }, /*#__PURE__*/_react.default.createElement("img", {
    alt: "...",
    src: image,
    className: "w-full align-middle rounded-t-lg"
  }), /*#__PURE__*/_react.default.createElement("blockquote", {
    className: "relative p-8 mb-4"
  }, /*#__PURE__*/_react.default.createElement("svg", {
    preserveAspectRatio: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 583 95",
    className: "absolute left-0 w-full block h-95-px -top-94-px"
  }, /*#__PURE__*/_react.default.createElement("polygon", {
    points: "-30,95 583,95 583,65",
    className: textColor[color] + " fill-current"
  })), /*#__PURE__*/_react.default.createElement("h4", {
    className: "text-xl font-bold text-white"
  }, title), /*#__PURE__*/_react.default.createElement("p", {
    className: "text-md font-light mt-2 text-white"
  }, description))));
}

CardBlogImage.defaultProps = {
  color: "blueGray"
};
CardBlogImage.propTypes = {
  image: _propTypes.default.string,
  title: _propTypes.default.string,
  description: _propTypes.default.string,
  // the background of the bottom part of the card
  color: _propTypes.default.oneOf(["blueGray", "red", "orange", "amber", "emerald", "teal", "lightBlue", "indigo", "purple", "pink"])
};
